import { Megaphone } from "lucide-react";

const AnnouncementTileDesign = {
  id: "announcements",
  icon: Megaphone,
  label: "Announcements",
  background: "#5F7D4D",
  color: "#ffffff",
};

export default AnnouncementTileDesign;
